import { render, staticRenderFns } from "./ProductATCModal.vue?vue&type=template&id=04417fd8&"
import script from "./ProductATCModal.vue?vue&type=script&lang=ts&"
export * from "./ProductATCModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports